export function isNoDisplayValue(attrValue) {
    return undefined === attrValue || null === attrValue || false === attrValue;
}
